import script from "./EventItemForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventItemForm.vue?vue&type=script&lang=ts&setup=true"

import "./EventItemForm.vue?vue&type=style&index=0&id=6a4e4853&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a4e4853"]])

export default __exports__